import React, { useEffect, useRef } from 'react'

import Head from 'next/head'

import { useRouterExtend } from 'hooks/useRouterExtend'
import { LOCALE } from 'interfaces/types'

if (typeof window !== 'undefined') {
  window.anymindTS = window.anymindTS || { que: [] }
}

const ALLOW_LOCALE: LOCALE[] = [
  // LOCALE.PhilippinesTagalog,
  // LOCALE.PhilippinesEnglish
]

export const runAts = () => {
  if (typeof window !== 'undefined') {
    window.anymindTS.que.push(function () {
      window.startAnymindTS()
    })
  }
}

export const disposeAts = () => {
  if (typeof window !== 'undefined') {
    window.anymindTS.que.push(function () {
      window.anymindTS.dispose()
    })
  }
}

const ATSManager = () => {
  const { locale } = useRouterExtend()
  const didRunAts = useRef(false) // ensure call runAts once
  const didDisposeAts = useRef(false) // ensure call disposeAts once

  useEffect(() => {
    if (!didRunAts.current) {
      console.log('run ats')
      runAts()
      didRunAts.current = true
    }
    return () => {
      if (!didDisposeAts.current && didRunAts.current) {
        console.log('dispose ats')
        disposeAts()
      }
    }
  }, [])

  if (!ALLOW_LOCALE.includes(locale)) return null

  return (
    <Head>
      <script src="https://anymind360.com/js/14154/ats.js" async />
    </Head>
  )
}

export default ATSManager
